function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "canvas__infinity_node_icon-shape",
  x: 6,
  y: 4,
  width: 44,
  height: 26,
  rx: 4,
  fill: "#FFFFFF",
  stroke: "#373A3C",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  className: "canvas__infinity_node_icon-path",
  d: "M28 17.0303C28 17.0303 22.913 24.0606 19.0303 24.0606C15.1476 24.0606 12 20.913 12 17.0303C12 13.1476 15.1476 10 19.0303 10C22.913 10 28 17.0303 28 17.0303Z",
  fill: "#FFFFFF",
  stroke: "#373A3C",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "canvas__infinity_node_icon-path",
  d: "M28.0001 17.0303C28.0001 17.0303 33.087 10 36.9698 10C40.8525 10 44.0001 13.1476 44.0001 17.0303C44.0001 20.913 40.8525 24.0606 36.9698 24.0606C33.087 24.0606 28.0001 17.0303 28.0001 17.0303Z",
  fill: "#FFFFFF",
  stroke: "#373A3C",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 56,
  height: 38,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgInfinity = function SvgInfinity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 38,
    viewBox: "0 0 56 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfinity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/infinity.fcc6cebd.svg";
export { ForwardRef as ReactComponent };